import { IonContent, IonItem, IonList, IonPopover } from '@ionic/react';
import { useTranslate } from '../../../../../hooks/context/useTranslate';
import { getExportOptions } from '../../../../../utils/getExportOptions';

interface ExportPopoverProps {
  triggerId: string;
  onExport: (exportMode: string) => void;
}

const ExportPopover = ({ triggerId, onExport }: ExportPopoverProps) => {
  const { t } = useTranslate();
  const options = getExportOptions(t, onExport);
  return (
    <IonPopover
      trigger={triggerId}
      alignment="start"
      dismissOnSelect={true}
      showBackdrop={false}
    >
      <IonContent>
        <IonList>
          {options.map((option, optionIndex) => (
            <IonItem
              button={true}
              onClick={option.onClick}
              key={option.key}
              lines={optionIndex === options.length - 1 ? 'none' : 'full'}
            >
              {option.label}
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonPopover>
  );
};

export default ExportPopover;
